(() => {
  const body = document.body;
  const menu = document.getElementById('rdMenu');
  const scrim = document.querySelector('.rd-scrim');
  const menuTrigger = document.querySelector('[data-menu-open]');
  let lastFocused = null;

  const setInert = (node, inert) => {
    if (!node) return;
    if (inert) node.setAttribute('inert', ''); else node.removeAttribute('inert');
  };

  const trapFocus = (event, container) => {
    if (event.key !== 'Tab' || !container) return;
    const focusable = [...container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((node) => !node.hasAttribute('inert'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  const setMenu = (open) => {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    scrim?.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    setInert(menu, !open);
    menuTrigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('rd-menu-open', open);
    if (open) { lastFocused = document.activeElement; menu.querySelector('[data-menu-close]')?.focus(); }
    else if (lastFocused instanceof HTMLElement) lastFocused.focus();
  };

  menuTrigger?.addEventListener('click', () => setMenu(true));
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => setMenu(false)));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.querySelectorAll('[data-auto-submit]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));

  // The React prototype owns this gesture when data-swipe-enabled="react" is present.
  // This delegated fallback keeps the currently bundled Shopify home swipeable too.
  let threeMomentSwipe = null;
  const isThreeMomentsMobile = () => window.matchMedia('(max-width: 1024px)').matches;
  document.addEventListener('pointerdown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const gallery = target?.closest('.three-moments-gallery:not([data-swipe-enabled="react"])');
    if (!gallery || !event.isPrimary || !isThreeMomentsMobile()) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (target.closest('button, a')) return;

    threeMomentSwipe = {
      gallery,
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
    };
    gallery.setPointerCapture?.(event.pointerId);
  }, { passive: true });

  document.addEventListener('pointerup', (event) => {
    const origin = threeMomentSwipe;
    if (!origin || origin.pointerId !== event.pointerId) return;
    threeMomentSwipe = null;

    if (origin.gallery.hasPointerCapture?.(event.pointerId)) {
      origin.gallery.releasePointerCapture(event.pointerId);
    }

    const distanceX = event.clientX - origin.x;
    const distanceY = event.clientY - origin.y;
    const threshold = Math.max(36, Math.min(64, origin.gallery.clientWidth * 0.12));
    if (Math.abs(distanceX) < threshold || Math.abs(distanceX) <= Math.abs(distanceY) * 1.2) return;

    const experience = origin.gallery.closest('.three-moments-experience');
    const tabs = [...(experience?.querySelectorAll('.three-moments-tabs button') || [])];
    if (!tabs.length) return;
    const current = Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-pressed') === 'true' || tab.classList.contains('is-active')));
    const direction = distanceX < 0 ? 1 : -1;
    tabs[(current + direction + tabs.length) % tabs.length]?.click();
  }, { passive: true });

  document.addEventListener('pointercancel', (event) => {
    if (threeMomentSwipe?.pointerId === event.pointerId) threeMomentSwipe = null;
  }, { passive: true });

  const mainImage = document.getElementById('rdMainImage');
  const zoomImage = document.getElementById('rdZoomImage');
  const modal = document.getElementById('rdImageModal');
  const setZoom = (open) => {
    if (!modal) return;
    modal.classList.toggle('is-open', open);
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    setInert(modal, !open);
    body.classList.toggle('rd-menu-open', open);
    if (open) { lastFocused = document.activeElement; modal.querySelector('[data-zoom-close]')?.focus(); }
    else if (lastFocused instanceof HTMLElement) lastFocused.focus();
  };
  document.querySelector('[data-zoom-open]')?.addEventListener('click', () => setZoom(true));
  document.querySelector('[data-zoom-close]')?.addEventListener('click', () => setZoom(false));
  modal?.addEventListener('click', (event) => { if (event.target === modal) setZoom(false); });

  document.querySelectorAll('[data-gallery-src]').forEach((button) => {
    button.addEventListener('click', () => {
      if (mainImage) mainImage.src = button.dataset.gallerySrc;
      if (zoomImage) zoomImage.src = button.dataset.gallerySrc;
      document.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  const quantity = document.getElementById('rdQty');
  const changeQuantity = (amount) => {
    if (!quantity) return;
    quantity.value = Math.max(1, Number.parseInt(quantity.value || '1', 10) + amount);
  };
  document.querySelector('[data-qty-minus]')?.addEventListener('click', () => changeQuantity(-1));
  document.querySelector('[data-qty-plus]')?.addEventListener('click', () => changeQuantity(1));

  document.querySelectorAll('[data-variant-price]').forEach((radio) => {
    radio.addEventListener('change', () => {
      const price = radio.dataset.variantPrice;
      const productPrice = document.getElementById('rdProductPrice');
      const stickyPrice = document.getElementById('rdStickyPrice');
      if (productPrice) productPrice.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (radio.dataset.variantImage) {
        if (mainImage) mainImage.src = radio.dataset.variantImage;
        if (zoomImage) zoomImage.src = radio.dataset.variantImage;
      }
    });
  });

  const productForm = document.getElementById('rdProductForm');
  const sticky = document.getElementById('rdStickyBuy');
  const primaryAdd = productForm?.querySelector('.rd-add');
  const updateSticky = () => {
    if (!sticky || !primaryAdd) return;
    sticky.classList.toggle('is-visible', primaryAdd.getBoundingClientRect().bottom < 0);
  };
  updateSticky();
  window.addEventListener('scroll', updateSticky, { passive: true });
  document.querySelector('[data-sticky-submit]')?.addEventListener('click', () => productForm?.requestSubmit());

  const giftToggle = document.querySelector('[data-gift-toggle]');
  const giftFields = document.querySelector('[data-gift-fields]');
  const giftMessage = document.getElementById('rdGiftMessage');
  const giftCount = document.querySelector('[data-gift-count]');
  const syncGift = () => {
    const active = Boolean(giftToggle?.checked);
    giftFields?.classList.toggle('is-active', active);
    if (giftMessage) {
      giftMessage.disabled = !active;
      giftMessage.required = active;
      if (!active) giftMessage.value = '';
    }
    if (giftCount) giftCount.textContent = String(giftMessage?.value.length || 0);
  };
  giftToggle?.addEventListener('change', syncGift);
  giftMessage?.addEventListener('input', () => { if (giftCount) giftCount.textContent = String(giftMessage.value.length); });
  syncGift();

  const searchInput = document.getElementById('SearchInput');
  const predictive = document.getElementById('rdPredictiveResults');
  let searchTimer;
  let searchController;
  const formatEuro = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const normalized = typeof value === 'number'
      ? value
      : Number.parseFloat(String(value).replace(/[^0-9,.-]/g, '').replace(',', '.'));
    if (!Number.isFinite(normalized)) return String(value);
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(normalized);
  };
  const clearPredictive = () => {
    if (!predictive) return;
    predictive.hidden = true;
    predictive.replaceChildren();
    searchInput?.setAttribute('aria-expanded', 'false');
  };
  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchController?.abort();
    const query = searchInput.value.trim();
    if (query.length < 2) { clearPredictive(); return; }
    searchTimer = window.setTimeout(async () => {
      try {
        searchController = new AbortController();
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: searchController.signal });
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        predictive.replaceChildren();
        products.forEach((product) => {
          const link = document.createElement('a');
          link.href = product.url;
          link.setAttribute('role', 'option');
          if (product.featured_image?.url) {
            const image = document.createElement('img');
            image.src = product.featured_image.url;
            image.alt = '';
            link.appendChild(image);
          }
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = product.title;
          const price = document.createElement('small');
          price.textContent = formatEuro(product.price);
          copy.append(title, price);
          link.appendChild(copy);
          predictive.appendChild(link);
        });
        const all = document.createElement('a');
        all.href = `/search?q=${encodeURIComponent(query)}&type=product`;
        all.className = 'rd-predictive-all';
        all.textContent = products.length ? `VEDI TUTTI I RISULTATI PER “${query}” →` : `CERCA “${query}” NEL CATALOGO →`;
        predictive.appendChild(all);
        predictive.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') clearPredictive();
      }
    }, 220);
  });
  document.addEventListener('click', (event) => { if (predictive && !predictive.contains(event.target) && event.target !== searchInput) clearPredictive(); });

  let toastTimer;
  const notify = (message) => {
    let toast = document.querySelector('.rd-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'rd-toast';
      toast.setAttribute('role', 'status');
      body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  const refreshBagCount = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    const count = document.querySelector('.rd-nav-right a[href="/cart"] span');
    if (count) count.textContent = `(${cart.item_count})`;
  };

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const previous = submit?.innerHTML;
      if (submit) { submit.disabled = true; submit.textContent = 'AGGIUNGO…'; }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('add');
        await refreshBagCount();
        notify('Il tuo gioiello è nella bag');
        if (submit) submit.textContent = 'AGGIUNTO ✓';
      } catch {
        notify('Non siamo riusciti ad aggiungerlo. Riprova tra un momento.');
        if (submit) submit.textContent = 'RIPROVA';
      } finally {
        window.setTimeout(() => { if (submit) { submit.disabled = false; submit.innerHTML = previous; } }, 1400);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (menu?.classList.contains('is-open')) setMenu(false);
      if (modal?.classList.contains('is-open')) setZoom(false);
      clearPredictive();
    }
    if (menu?.classList.contains('is-open')) trapFocus(event, menu);
    if (modal?.classList.contains('is-open')) trapFocus(event, modal);
  });

  setInert(menu, !menu?.classList.contains('is-open'));
  setInert(modal, !modal?.classList.contains('is-open'));

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-seen'); observer.unobserve(entry.target); }
    }), { threshold: .08 });
    document.querySelectorAll('.rd-card').forEach((card) => observer.observe(card));
  } else {
    document.querySelectorAll('.rd-card').forEach((card) => card.classList.add('is-seen'));
  }
})();
